import { initialState } from './initialstate'

const ActivationCartModule = {
  namespaced: true,
  state: initialState,
  getters: {
    price: state => state.price,
    volume: state => state.volume,
    promoPrice: state => state.promoPrice,
    limitedVolume: state => state.limitedVolume,
    additionalPriceStairways: state => state.additionalPriceStairways,
    startingBonus: state => state.startingBonus,
    targetTariff: state => state.targetTariff,
    targetPromotions: state => state.targetPromotions
  },
  actions: {
    setActivationCart ({ commit, rootGetters, dispatch }, { tariffId = null, tariffoptionId = null, mnp = null, provider = null }) {
      const cart = rootGetters['promotion/getCartForSelection']({ mode: 'activation', tariffId, tariffoptionId, mnp, provider }) // enthält die presalesInclusivePromos
      dispatch('cart/processQueryResult', {
        tariff: cart.targetTariff,
        tariffoptions: cart.targetTariffoption,
        promotions: cart.targetPromotions
      }, { root: true }).then((result) => {
        commit('targetTariff', result.targetTariff)
        commit('targetTariffoptions', result.targetTariffoptions)
        commit('targetPromotions', result.targetPromotions)
        commit('promoBenefits', result.promoBenefits)
      })
      return true
    }
  },
  mutations: {
    targetTariff (state, tariff) {
      state.targetTariff = tariff
    },
    targetTariffoptions (state, tariffoptions) {
      state.targetTariffoptions = tariffoptions
    },
    targetPromotions (state, promotions) {
      state.targetPromotions = promotions
    },
    promoBenefits (state, { newVolume, newLimitedVolume, newPrice, newPromoPrice, additionalPriceStairways, newStartingBonus }) {
      state.volume = newVolume
      state.limitedVolume = newLimitedVolume
      state.price = newPrice
      state.promoPrice = newPromoPrice
      state.additionalPriceStairways = additionalPriceStairways
      state.startingBonus = newStartingBonus
    },
    resetState: (state) => {
      Object.assign(state, initialState)
    }
  }
}

export {
  ActivationCartModule
}
